
import { useStore } from "vuex";
import { computed, defineComponent } from "vue";
import { getGearImage, getItemPrefixData } from "@/data/gear-utils";
export default defineComponent({
  name: "CharacterTable",
  emits: ["equip"],
  components: {},
  setup() {
    const store = useStore();
    const equippedGear = computed(() => {
      const headBonusStatsCount =
        Object.keys(store.state.build.EquippedGear.head?.bonusStats || {})
          ?.length ?? null;
      const bodyBonusStatsCount =
        Object.keys(store.state.build.EquippedGear.body?.bonusStats || {})
          ?.length ?? null;
      return {
        w1: null,
        w2: null,
        head: store.state.build.EquippedGear.head ?? null,
        headBonusStatsCount,
        body: store.state.build.EquippedGear.body ?? null,
        bodyBonusStatsCount,
      };
    });
    return {
      state: store.state,
      equippedGear,
      getGearImage,
      getItemPrefixData,
    };
  },
});
